const selectSelectedProduct = (state) => {
  const { selectedProductId, formData } = state.app;
  return formData.products.find(({ id }) => id === selectedProductId);
};

export default selectSelectedProduct;
